const isLocalhost = Boolean(
    window.location.hostname === 'localhost'
        || window.location.hostname === '[::1]'
        || window.location.hostname.match(
            /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
);

const handleRegistrationWaiting = (registration, config) => {
    if (config && typeof config.onUpdate === 'function') {
        config.onUpdate(registration);
    }
};

const handleRegistrationSuccess = (registration, config) => {
    if (config && typeof config.onSuccess === 'function') {
        config.onSuccess(registration);
    }
};

const registerValidSW = (swUrl, config) => {
    navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
            if (registration.waiting) {
                handleRegistrationWaiting(registration, config);
            }

            registration.addEventListener('updatefound', () => {
                const installingWorker = registration.installing;

                if (!installingWorker) {
                    return;
                }

                installingWorker.addEventListener('statechange', () => {
                    if (installingWorker.state === 'installed') {
                        if (navigator.serviceWorker.controller) {
                            handleRegistrationWaiting(registration, config);
                        }
                        else {
                            handleRegistrationSuccess(registration, config);
                        }
                    }
                });
            });
        })
        .catch((error) => {
            console.error('Service worker registration failed:', error);
        });
};

const checkValidServiceWorker = (swUrl, config) => {
    fetch(swUrl, {
        headers: {
            'Service-Worker': 'script'
        }
    })
        .then((response) => {
            const contentType = response.headers.get('content-type');

            if (response.status === 404 || (contentType && contentType.indexOf('javascript') === -1)) {
                navigator.serviceWorker.ready.then((registration) => {
                    registration.unregister().then(() => {
                        window.location.reload();
                    });
                });
            }
            else {
                registerValidSW(swUrl, config);
            }
        })
        .catch(() => {
            console.log('No internet connection found. App is running in offline mode.');
        });
};

export const register = (config) => {
    if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
        return;
    }

    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);

    if (publicUrl.origin !== window.location.origin) {
        return;
    }

    window.addEventListener('load', () => {
        const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

        if (isLocalhost) {
            checkValidServiceWorker(swUrl, config);
            navigator.serviceWorker.ready.then(() => {
                console.log('This web app is served cache-first by a service worker.');
            });
        }
        else {
            registerValidSW(swUrl, config);
        }
    });
};

export const unregister = () => {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready
            .then((registration) => {
                registration.unregister();
            })
            .catch((error) => {
                console.error(error.message);
            });
    }
};

